const AssetManagement = () => {
    return (
        <>
            <section>

            </section>
        </>
    )
}
export default AssetManagement